module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5RKF2"))).then(() => parcelRequire('2KbAe'));